import { render } from "./UiPagination.vue?vue&type=template&id=c8e42924"
import script from "./UiPagination.vue?vue&type=script&lang=js"
export * from "./UiPagination.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__